import React from 'react';
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import { colors, fonts, spacing, borderRadius } from '../../constants';

/**
 * QuickSearchItem Component
 * Individual quick search menu item
 */
const QuickSearchItem = ({
  primary,
  secondary,
  onClick,
  isLast = false,
}) => {
  return (
    <ListItem 
      disablePadding 
      sx={{ 
        mb: isLast ? 0 : '4px',
      }}
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          borderRadius: borderRadius.sm,
          py: '8px',
          px: spacing.sm,
          minHeight: 'auto',
          transition: 'all 0.15s ease',
          '&:hover': {
            backgroundColor: colors.backgroundSoft,
            transform: 'translateX(2px)',
          },
        }}
      >
        <ListItemText
          primary={primary}
          secondary={secondary}
          primaryTypographyProps={{
            sx: {
              fontSize: fonts.fontSizeSm,
              fontWeight: fonts.weightMedium,
              color: primary === 'My Queries' ? colors.textWhite : colors.textPrimaryDark,
              lineHeight: 1.3,
              mb: '2px',
            },
          }}
          secondaryTypographyProps={{
            sx: {
              fontSize: fonts.fontSizeXs,
              color: colors.textSecondary,
              lineHeight: 1.2,
              mt: 0,
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default QuickSearchItem;
